import apiService from '../../../apiService'
import constants from '../../../../../../../../resources/js/constants'
import Notification from '../../../../../../../../resources/js/notification'

export default {
  namespaced: true,
  state: {
    client: {},
    fetching: true
  },
  mutations: {
    set (state, client) {
      state.client = client
    }
  },
  actions: {
    fetch ({ state, commit }) {
      state.fetching = true

      apiService.getClientInfo()
        .then(response => {
          commit('set', response.data.client)
          window.vue.$emit('clientInfoLoaded')

          state.fetching = false
        })
        .catch(() => {
          state.fetching = false

          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить информацию о клиенте.'
          })
        })
    }
  },
  getters: {
    isStatusCanBeUpgraded: state => state.client.loyalty_status ? state.client.loyalty_status !== constants.LOYALTY_STATUS_PLATINUM : null,
    isCurrentStatus: state => status => state.client.loyalty_status === status,
    /**
     * @deprecated
     */
    isDemo: state => state.client.login === 'demo'
  }
}
